(() => {
  const AVAILABILITY_PARAM = 'filter.v.availability';
  let scheduled = false;

  const removeAvailabilityFromUrl = () => {
    const url = new URL(window.location.href);
    if (!url.searchParams.has(AVAILABILITY_PARAM)) return;
    url.searchParams.delete(AVAILABILITY_PARAM);
    window.history.replaceState(window.history.state, '', url.toString());
  };

  const scrubAvailabilityUi = () => {
    document
      .querySelectorAll(
        `.facets-container [id*="${AVAILABILITY_PARAM}"],
         .facets-container a[href*="${AVAILABILITY_PARAM}"],
         .facets-container input[name="${AVAILABILITY_PARAM}"],
         .facets-container [data-param-name="${AVAILABILITY_PARAM}"]`,
      )
      .forEach((element) => {
        const removable =
          element.closest('details.js-filter') ||
          element.closest('facet-remove') ||
          element.closest('.active-facets__button-wrapper') ||
          element;
        removable.remove();
      });

    // Active-facet removal URLs no longer contain the parameter they remove,
    // so also guard against stale server/AJAX markup by its visible label.
    document.querySelectorAll('.facets-container .active-facets__button').forEach((button) => {
      const label = button.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      if (label.startsWith('availability:')) button.closest('facet-remove')?.remove();
    });

    document.querySelectorAll('.active-facets-desktop, .active-facets-mobile').forEach((container) => {
      const activeButtons = Array.from(container.querySelectorAll('.active-facets__button')).filter(
        (button) => !button.classList.contains('active-facets__button-remove'),
      );
      container.querySelectorAll('.active-facets__button-wrapper').forEach((clearButton) => {
        if (activeButtons.length === 0) clearButton.remove();
      });
      container.hidden = activeButtons.length === 0;
    });
  };

  const run = () => {
    scheduled = false;
    removeAvailabilityFromUrl();
    scrubAvailabilityUi();
  };

  const scheduleRun = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(run);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes.length)) scheduleRun();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
